import React from 'react';
import { Grid } from '@mui/material';
import { Form } from 'formik';
import * as Yup from 'yup';
import { MuiForm } from 'lib/Form';
import { TextFormField } from 'lib/form/fields/TextFormField';
import { MuiFormLabel } from 'lib/form/MuiFormLabel';
import { LoadingButton } from 'ui/buttons/LoadingButton';
import { Row } from 'ui/Flex';

export interface PasswordResetFormData {
    email: string;
}

interface PasswordResetFormProps {
    onSubmit: (data: PasswordResetFormData) => void;
}

const initialValues: PasswordResetFormData = {
    email: ''
};

const validationSchema = Yup.object().shape({
    email: Yup.string().email('Invalid email.').required('Email is required.')
});

export const PasswordResetForm: React.FC<PasswordResetFormProps> = ({ onSubmit }) => {
    const emailRef = React.useRef(null);
    React.useEffect(() => {
        if (emailRef && !!emailRef.current) {
            emailRef.current.focus();
        }
    }, []);
    const handleKeyDown = React.useCallback(
        (submitForm: () => void) => (e: React.KeyboardEvent) => e.keyCode === 13 && submitForm(),
        []
    );
    return (
        <MuiForm onSubmit={onSubmit} initialValues={initialValues} validationSchema={validationSchema}>
            {({ submitForm, isSubmitting }) => (
                <Form>
                    <Grid container spacing={2}>
                        <Grid size={12}>
                            <TextFormField
                                name="email"
                                type="email"
                                label={<MuiFormLabel required>Email</MuiFormLabel>}
                                inputRef={emailRef}
                                onKeyDown={handleKeyDown(submitForm)}
                            />
                        </Grid>
                        <Grid size={12}>
                            <Row flex={1} align="flex-end">
                                <LoadingButton
                                    variant="contained"
                                    color="primary"
                                    disabled={isSubmitting}
                                    loading={isSubmitting}
                                    onClick={submitForm}
                                >
                                    Submit
                                </LoadingButton>
                            </Row>
                        </Grid>
                    </Grid>
                </Form>
            )}
        </MuiForm>
    );
};
